import React from 'react';
import styled from 'styled-components';
import statsCount from '../../../Data/statsCount';

export const StatsContainer = styled.div`
  width: var(--layoutWidth);
  max-width: var(--layoutMaxWidth);
  margin: 0px auto;
  padding: 0px 20px;
  @media (min-width: 992px) {
    padding: 0px;
  }
`;

export const StatsContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  @media (min-width: 768px) {
    ::before {
      content: '';
      display: inline-block;
      width: 100%;
      height: 1px;
      background-color: var(--greyShadowColor);
    }
    ::after {
      content: '';
      display: inline-block;
      width: 100%;
      height: 1px;
      background-color: var(--greyShadowColor);
    }
  }
`;

export const StatsText = styled.p`
  display: inline-block;
  text-align: center;
  font-size: 14px;
  font-family: var(--headingFont);
  @media (min-width: 768px) {
    font-size: 15px;
    padding: 0px 15px;
    white-space: nowrap;
  }
  @media (min-width: 1200px) {
    font-size: 16px;
  }
  @media (min-width: 2000px) {
    font-size: 18px;
  }
`;

export const StatsSpecialText = styled.span`
  display: inline-block;
  background: linear-gradient(90deg, var(--gradientPrimaryColor), var(--gradientSecondaryColor));
  -ms-background-clip: text;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: var(--headingFont);
  font-weight: 500;
  font-size: 15px;
  @media (min-width: 768px) {
    font-size: 16px;
  }
  @media (min-width: 1200px) {
    font-size: 18px;
  }
  @media (min-width: 2000px) {
    font-size: 20px;
  }
`;

export const StatsBrandText = styled.span`
  display: inline-block;
  color: ${({ variant }) =>
    variant === 'partner-plus'
      ? 'var(--partnerPlusColor)'
      : variant === 'regionals'
      ? 'var(--regionalsDark)'
      : variant === 'code-juniors'
      ? 'var(--codeJuniorsColor)'
      : 'var(--brandColor)'};
  font-family: var(--headingFont);
  font-weight: 500;
  font-size: 15px;
  @media (min-width: 768px) {
    font-size: 16px;
  }
  @media (min-width: 1200px) {
    font-size: 18px;
  }
  @media (min-width: 2000px) {
    font-size: 20px;
  }
`;

export const CompanyLogoContanier = styled.div`
  width: var(--layoutWidth);
  max-width: var(--layoutMaxWidth);
  margin: 0px auto;
  padding: 10px 20px 15px 20px;
  @media (min-width: 992px) {
    padding: 10px 0px 15px 0px;
  }
`;

export const CompaniesImgWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export const CompaniesImg = styled.object`
  width: 100%;
  height: 100%;
  pointer-events: none;
`;

export function SiteStats({ variant }) {
  return (
    <StatsContainer>
      <StatsContent>
        <StatsText>
          TRUSTED BY{' '}
          {/*{variant === 'partner-plus' || variant === 'regionals' || variant === 'code-juniors' ? (
            <StatsBrandText variant={variant}>{statsCount.Users.integer}+</StatsBrandText>
          ) : (
          )}*/}
          <StatsSpecialText>{statsCount.Users.integer}+</StatsSpecialText> LEARNERS <span className="no-text-wrap">ALL OVER THE WORLD</span>
        </StatsText>
      </StatsContent>
    </StatsContainer>
  );
}

export function CompanyLogos({ cloudFront }) {
  return (
    <CompanyLogoContanier>
      <CompaniesImgWrapper>
        <CompaniesImg data={cloudFront + '/Assets/homePage/CollegeCompaniesLogoNew.svg'}>Company Logo</CompaniesImg>
      </CompaniesImgWrapper>
    </CompanyLogoContanier>
  );
}
